import React from 'react';

const OnerikLogoSmall = () => {
  return (
    <div className="relative flex items-center justify-center w-9 h-9">
      <svg 
        width="100%" 
        height="100%" 
        viewBox="0 0 200 200" 
        fill="none" 
        xmlns="http://www.w3.org/2000/svg"
      >
        <defs>
          <radialGradient id="logoGradientSmall" cx="50%" cy="50%" r="50%">
            <stop offset="0%" stopColor="#1e3a8a" stopOpacity="1" />
            <stop offset="50%" stopColor="#0f172a" stopOpacity="1" />
            <stop offset="100%" stopColor="#000000" stopOpacity="1" />
          </radialGradient>
          <filter id="glowSmall">
            <feGaussianBlur stdDeviation="4" result="coloredBlur"/>
            <feMerge>
              <feMergeNode in="coloredBlur"/>
              <feMergeNode in="SourceGraphic"/>
            </feMerge>
          </filter>
        </defs>
        
        {/* Outer circle */}
        <circle 
          cx="100" 
          cy="100" 
          r="90" 
          fill="url(#logoGradientSmall)"
          stroke="#1e3a8a"
          strokeWidth="2"
          filter="url(#glowSmall)"
        />
        
        {/* Orbital rings */}
        <ellipse 
          cx="100" 
          cy="100" 
          rx="70" 
          ry="30" 
          fill="none"
          stroke="#3b82f6"
          strokeWidth="1.5"
          opacity="0.6"
          transform="rotate(45 100 100)"
        />
        <ellipse 
          cx="100" 
          cy="100" 
          rx="70" 
          ry="30" 
          fill="none"
          stroke="#3b82f6"
          strokeWidth="1.5"
          opacity="0.6"
          transform="rotate(-45 100 100)"
        />
        
        {/* Center glow */}
        <circle 
          cx="100" 
          cy="100" 
          r="15" 
          fill="#60a5fa"
          opacity="0.8"
        />
        <circle 
          cx="100" 
          cy="100" 
          r="8" 
          fill="#93c5fd"
        />
      </svg>
    </div>
  );
};

export default OnerikLogoSmall;
